<template>
  <div class="singer">
    <trending></trending>
    <singler-list></singler-list>
    <partner></partner>
  </div>
</template>

<script>
  import Trending from './Trending'
  import Partner from '../../home/wap/Partner'
  import ListSinger from './ListSinger'

  export default {
    name: "Singer",
    components: {
      "trending": Trending,
      "partner": Partner,
      "singler-list": ListSinger
    },
    data () {
      return {

      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .singer{
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/singer/wap/Singer.vue